module.exports = __webpack_public_path__ + "fonts/Gilroy-Bold.woff?32750b00d6f5003097a67377a4af208f";